"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionStore = void 0;
const mobx_1 = require("mobx");
class SessionStore {
    driver;
    token = null;
    user = null;
    constructor(driver) {
        this.driver = driver;
        (0, mobx_1.makeAutoObservable)(this, { driver: false });
        if (driver) {
            const cached = driver.get();
            if (cached) {
                this.token = cached.token;
                this.user = cached.user;
            }
        }
    }
    get isAuthenticated() {
        return this.token !== null && this.user !== null;
    }
    get isAdmin() {
        return this.user?.role === 'admin';
    }
    get isBanned() {
        return typeof this.user?.bannedAt === 'string' && this.user.bannedAt.length > 0;
    }
    signIn(token, user) {
        this.token = token;
        this.user = user;
        this.driver?.set({ token, user });
    }
    signOut() {
        this.token = null;
        this.user = null;
        this.driver?.clear();
    }
}
exports.SessionStore = SessionStore;
//# sourceMappingURL=session-store.js.map